// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */

:root {
  --white: #ffffff;
  --ivory: #fdfaf6;
  --cream: #f6eee6;
  --beige: #e8d8ca;
  --taupe: #a98269;
  --brown: #6f5141;
  --dark: #332822;
}

/* GENERAL */

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  color: var(--dark);
  background: var(--ivory);
  font-family: "Montserrat", sans-serif;
}

h1,
h2,
h3 {
  font-family: "Cormorant Garamond", serif;
}

.eyebrow {
  margin: 0 0 25px;
  color: #806554;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
}

/* PAGE BACKGROUND */

.salon-page {
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* HERO */

.hero {
  min-height: calc(100vh - 90px);
  position: relative;
  display: flex;
  align-items: center;
  background: transparent;
}

.hero-overlay {
  position: absolute;
  inset: 0;

  background: linear-gradient(
    90deg,
    rgba(253, 248, 242, 0.97) 0%,
    rgba(253, 248, 242, 0.9) 30%,
    rgba(253, 248, 242, 0.55) 52%,
    rgba(253, 248, 242, 0.08) 75%
  );
}

.hero-content {
  width: 100%;
  max-width: 750px;
  position: relative;
  z-index: 2;
  padding: 100px 8vw;
}

.hero h1 {
  margin: 0;
  color: #392b25;
  font-size: clamp(4.5rem, 7vw, 7.5rem);
  font-weight: 500;
  line-height: 0.85;
  letter-spacing: -2px;
}

.hero h1 em {
  color: #a8795e;
  font-weight: 400;
}

.hero-description {
  max-width: 600px;
  margin-top: 40px;
  color: #64564d;
  font-size: 1rem;
  line-height: 1.9;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 40px;
}

/* BUTTONS */

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 17px 30px;
  border: 1px solid var(--dark);

  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 2px;

  text-decoration: none;
  text-transform: uppercase;

  transition: all 0.3s ease;
}

.button-primary {
  color: var(--white);
  background: var(--dark);
}

.button-primary:hover {
  background: #9b7862;
  border-color: #9b7862;
}

.button-outline {
  color: var(--dark);
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
}

.button-outline:hover {
  background: rgba(255, 255, 255, 0.9);
}

/* SECTION HEADINGS */

.section-header {
  max-width: 750px;
  margin-bottom: 70px;
}

.section-header h2,
.about-section h2 {
  margin: 0;
  font-size: clamp(3.5rem, 5vw, 5.5rem);
  font-weight: 500;
  line-height: 0.95;
}

.section-header h2 em,
.about-section h2 em {
  color: var(--taupe);
  font-weight: 400;
}

.section-header > p:last-child {
  max-width: 550px;
  margin-top: 25px;
  color: #74665d;
  line-height: 1.8;
}

/* SERVICES */

.services-section {
  padding: 130px 8vw;
  background: rgba(246, 238, 230, 0.9);
  backdrop-filter: blur(2px);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  border-top: 1px solid rgba(169, 130, 105, 0.35);
  border-left: 1px solid rgba(169, 130, 105, 0.35);
}

.service-card {
  min-height: 260px;
  padding: 40px;

  border-right: 1px solid rgba(169, 130, 105, 0.35);
  border-bottom: 1px solid rgba(169, 130, 105, 0.35);

  background: rgba(255, 255, 255, 0.22);

  transition:
    background 0.3s ease,
    transform 0.3s ease;
}

.service-card:hover {
  background: rgba(255, 255, 255, 0.78);
  transform: translateY(-4px);
}

.service-card h3 {
  margin: 20px 0 10px;
  font-size: 2.2rem;
  font-weight: 500;
}

.service-card p {
  color: #75675e;
  font-size: 0.9rem;
  line-height: 1.8;
}

/* ABOUT */

.about-section {
  padding: 150px 12vw;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(2px);
}

.about-content {
  max-width: 850px;
}

.about-content > p:not(.eyebrow) {
  max-width: 650px;
  margin-top: 25px;
  color: #76675e;
  line-height: 1.9;
}

/* TEAM */

.team-section {
  padding: 130px 0;
  background: rgba(253, 250, 246, 0.9);
  backdrop-filter: blur(2px);
  overflow: hidden;
}

.team-section .section-header {
  margin-left: 8vw;
  margin-right: 8vw;
}

.team-slider {
  width: 100%;
  overflow: hidden;
}

.team-track {
  display: flex;
  width: max-content;
  gap: 25px;

  animation: teamScroll 30s linear infinite;
}

.team-slider:hover .team-track {
  animation-play-state: paused;
}

.team-card {
  width: 300px;
  flex: 0 0 300px;
  padding-bottom: 20px;
}

.team-photo {
  width: 100%;
  height: 420px;
  overflow: hidden;

  background: rgba(232, 216, 202, 0.8);
}

.team-image {
  width: 100%;
  height: 100%;
  display: block;

  object-fit: cover;
  object-position: center;

  transition: transform 0.4s ease;
}

.team-card:hover .team-image {
  transform: scale(1.03);
}

.team-card h3 {
  margin: 20px 0 0;
  font-size: 2rem;
  font-weight: 500;
}

.team-card p {
  margin-top: 3px;
  color: #9b7c69;
  font-size: 0.65rem;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

@keyframes teamScroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(calc(-50% - 12.5px));
  }
}

/* BOOK APPOINTMENT */

.booking-section {
  min-height: 550px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 130px 8vw;

  background: rgba(246, 238, 230, 0.9);
  backdrop-filter: blur(2px);

  text-align: center;
}

.booking-content {
  width: 100%;
  max-width: 750px;
}

.booking-section h2 {
  margin: 0;
  color: var(--dark);

  font-size: clamp(3.5rem, 5vw, 5.5rem);
  font-weight: 500;
  line-height: 0.95;
}

.booking-section h2 em {
  color: var(--taupe);
  font-weight: 400;
}

.booking-description {
  max-width: 600px;
  margin: 30px auto 40px;

  color: #74665d;
  font-size: 0.95rem;
  line-height: 1.9;
}

.booking-section .button {
  margin-top: 5px;
}

/* GALLERY */

.gallery-section {
  padding: 130px 8vw;

  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(2px);
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 300px;
  gap: 18px;
}

.gallery-item {
  position: relative;
  overflow: hidden;

  background: rgba(232, 216, 202, 0.8);
}

.gallery-item:nth-child(1) {
  grid-row: span 2;
}

.gallery-item:nth-child(4) {
  grid-row: span 2;
}

.gallery-image {
  width: 100%;
  height: 100%;
  display: block;

  object-fit: cover;
  object-position: center;

  transition:
    transform 0.5s ease,
    filter 0.5s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.04);
  filter: brightness(0.92);
}

/* TABLET */

@media (max-width: 900px) {
  .salon-page {
    background-attachment: scroll;
    background-position: center;
  }

  .hero {
    min-height: 850px;
  }

  .hero-overlay {
    background: rgba(253, 248, 242, 0.82);
  }

  .hero-content {
    padding: 100px 30px;
  }

  .hero h1 {
    font-size: 4.5rem;
  }

  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .team-card {
    width: 270px;
    flex-basis: 270px;
  }

  .team-photo {
    height: 380px;
  }

  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 280px;
  }
}

/* MOBILE */

@media (max-width: 600px) {
  .hero h1 {
    font-size: 3.8rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  .services-section,
  .booking-section,
  .gallery-section,
  .about-section {
    padding: 90px 25px;
  }

  .team-section {
    padding: 90px 0;
  }

  .team-section .section-header {
    margin-left: 25px;
    margin-right: 25px;
  }

  .team-card {
    width: 240px;
    flex-basis: 240px;
  }

  .team-photo {
    height: 340px;
  }

  .team-track {
    gap: 18px;
    animation-duration: 25s;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
    grid-auto-rows: 350px;
  }

  .gallery-item:nth-child(1),
  .gallery-item:nth-child(4) {
    grid-row: span 1;
  }

  .hero-actions {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/SalonHome.css"],"names":[],"mappings":"AAEA,WAAW;;AAEX;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY;;AAEZ;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,oBAAoB;;AAEpB;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,SAAS;;AAET;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER;;;;;;GAMC;AACH;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;;EAE7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;;EAEnB,qBAAqB;EACrB,yBAAyB;;EAEzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;;AAErB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;;EAErC,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,aAAa;;EAEb,iDAAiD;EACjD,kDAAkD;;EAElD,qCAAqC;;EAErC;;uBAEqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,UAAU;;AAEV;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;;AAET;EACE,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;;EAET,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;;EAEhB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;;EAEd,iBAAiB;EACjB,uBAAuB;;EAEvB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA,qBAAqB;;AAErB;EACE,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,oCAAoC;EACpC,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;;EAElB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;;EAEtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY;;AAEZ;EACE,kBAAkB;;EAElB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;EAEhB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;;EAEd,iBAAiB;EACjB,uBAAuB;;EAEvB;;oBAEkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,WAAW;;AAEX;EACE;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,qBAAqB;EACvB;AACF;;AAEA,WAAW;;AAEX;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap\");\n\n/* COLORS */\n\n:root {\n  --white: #ffffff;\n  --ivory: #fdfaf6;\n  --cream: #f6eee6;\n  --beige: #e8d8ca;\n  --taupe: #a98269;\n  --brown: #6f5141;\n  --dark: #332822;\n}\n\n/* GENERAL */\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  color: var(--dark);\n  background: var(--ivory);\n  font-family: \"Montserrat\", sans-serif;\n}\n\nh1,\nh2,\nh3 {\n  font-family: \"Cormorant Garamond\", serif;\n}\n\n.eyebrow {\n  margin: 0 0 25px;\n  color: #806554;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n}\n\n/* PAGE BACKGROUND */\n\n.salon-page {\n  width: 100%;\n  min-height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n/* HERO */\n\n.hero {\n  min-height: calc(100vh - 90px);\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: transparent;\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n\n  background: linear-gradient(\n    90deg,\n    rgba(253, 248, 242, 0.97) 0%,\n    rgba(253, 248, 242, 0.9) 30%,\n    rgba(253, 248, 242, 0.55) 52%,\n    rgba(253, 248, 242, 0.08) 75%\n  );\n}\n\n.hero-content {\n  width: 100%;\n  max-width: 750px;\n  position: relative;\n  z-index: 2;\n  padding: 100px 8vw;\n}\n\n.hero h1 {\n  margin: 0;\n  color: #392b25;\n  font-size: clamp(4.5rem, 7vw, 7.5rem);\n  font-weight: 500;\n  line-height: 0.85;\n  letter-spacing: -2px;\n}\n\n.hero h1 em {\n  color: #a8795e;\n  font-weight: 400;\n}\n\n.hero-description {\n  max-width: 600px;\n  margin-top: 40px;\n  color: #64564d;\n  font-size: 1rem;\n  line-height: 1.9;\n}\n\n.hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-top: 40px;\n}\n\n/* BUTTONS */\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 17px 30px;\n  border: 1px solid var(--dark);\n\n  font-size: 0.7rem;\n  font-weight: 500;\n  letter-spacing: 2px;\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  transition: all 0.3s ease;\n}\n\n.button-primary {\n  color: var(--white);\n  background: var(--dark);\n}\n\n.button-primary:hover {\n  background: #9b7862;\n  border-color: #9b7862;\n}\n\n.button-outline {\n  color: var(--dark);\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(5px);\n}\n\n.button-outline:hover {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n/* SECTION HEADINGS */\n\n.section-header {\n  max-width: 750px;\n  margin-bottom: 70px;\n}\n\n.section-header h2,\n.about-section h2 {\n  margin: 0;\n  font-size: clamp(3.5rem, 5vw, 5.5rem);\n  font-weight: 500;\n  line-height: 0.95;\n}\n\n.section-header h2 em,\n.about-section h2 em {\n  color: var(--taupe);\n  font-weight: 400;\n}\n\n.section-header > p:last-child {\n  max-width: 550px;\n  margin-top: 25px;\n  color: #74665d;\n  line-height: 1.8;\n}\n\n/* SERVICES */\n\n.services-section {\n  padding: 130px 8vw;\n  background: rgba(246, 238, 230, 0.9);\n  backdrop-filter: blur(2px);\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n\n  border-top: 1px solid rgba(169, 130, 105, 0.35);\n  border-left: 1px solid rgba(169, 130, 105, 0.35);\n}\n\n.service-card {\n  min-height: 260px;\n  padding: 40px;\n\n  border-right: 1px solid rgba(169, 130, 105, 0.35);\n  border-bottom: 1px solid rgba(169, 130, 105, 0.35);\n\n  background: rgba(255, 255, 255, 0.22);\n\n  transition:\n    background 0.3s ease,\n    transform 0.3s ease;\n}\n\n.service-card:hover {\n  background: rgba(255, 255, 255, 0.78);\n  transform: translateY(-4px);\n}\n\n.service-card h3 {\n  margin: 20px 0 10px;\n  font-size: 2.2rem;\n  font-weight: 500;\n}\n\n.service-card p {\n  color: #75675e;\n  font-size: 0.9rem;\n  line-height: 1.8;\n}\n\n/* ABOUT */\n\n.about-section {\n  padding: 150px 12vw;\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: blur(2px);\n}\n\n.about-content {\n  max-width: 850px;\n}\n\n.about-content > p:not(.eyebrow) {\n  max-width: 650px;\n  margin-top: 25px;\n  color: #76675e;\n  line-height: 1.9;\n}\n\n/* TEAM */\n\n.team-section {\n  padding: 130px 0;\n  background: rgba(253, 250, 246, 0.9);\n  backdrop-filter: blur(2px);\n  overflow: hidden;\n}\n\n.team-section .section-header {\n  margin-left: 8vw;\n  margin-right: 8vw;\n}\n\n.team-slider {\n  width: 100%;\n  overflow: hidden;\n}\n\n.team-track {\n  display: flex;\n  width: max-content;\n  gap: 25px;\n\n  animation: teamScroll 30s linear infinite;\n}\n\n.team-slider:hover .team-track {\n  animation-play-state: paused;\n}\n\n.team-card {\n  width: 300px;\n  flex: 0 0 300px;\n  padding-bottom: 20px;\n}\n\n.team-photo {\n  width: 100%;\n  height: 420px;\n  overflow: hidden;\n\n  background: rgba(232, 216, 202, 0.8);\n}\n\n.team-image {\n  width: 100%;\n  height: 100%;\n  display: block;\n\n  object-fit: cover;\n  object-position: center;\n\n  transition: transform 0.4s ease;\n}\n\n.team-card:hover .team-image {\n  transform: scale(1.03);\n}\n\n.team-card h3 {\n  margin: 20px 0 0;\n  font-size: 2rem;\n  font-weight: 500;\n}\n\n.team-card p {\n  margin-top: 3px;\n  color: #9b7c69;\n  font-size: 0.65rem;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n}\n\n@keyframes teamScroll {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(calc(-50% - 12.5px));\n  }\n}\n\n/* BOOK APPOINTMENT */\n\n.booking-section {\n  min-height: 550px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 130px 8vw;\n\n  background: rgba(246, 238, 230, 0.9);\n  backdrop-filter: blur(2px);\n\n  text-align: center;\n}\n\n.booking-content {\n  width: 100%;\n  max-width: 750px;\n}\n\n.booking-section h2 {\n  margin: 0;\n  color: var(--dark);\n\n  font-size: clamp(3.5rem, 5vw, 5.5rem);\n  font-weight: 500;\n  line-height: 0.95;\n}\n\n.booking-section h2 em {\n  color: var(--taupe);\n  font-weight: 400;\n}\n\n.booking-description {\n  max-width: 600px;\n  margin: 30px auto 40px;\n\n  color: #74665d;\n  font-size: 0.95rem;\n  line-height: 1.9;\n}\n\n.booking-section .button {\n  margin-top: 5px;\n}\n\n/* GALLERY */\n\n.gallery-section {\n  padding: 130px 8vw;\n\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: blur(2px);\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-auto-rows: 300px;\n  gap: 18px;\n}\n\n.gallery-item {\n  position: relative;\n  overflow: hidden;\n\n  background: rgba(232, 216, 202, 0.8);\n}\n\n.gallery-item:nth-child(1) {\n  grid-row: span 2;\n}\n\n.gallery-item:nth-child(4) {\n  grid-row: span 2;\n}\n\n.gallery-image {\n  width: 100%;\n  height: 100%;\n  display: block;\n\n  object-fit: cover;\n  object-position: center;\n\n  transition:\n    transform 0.5s ease,\n    filter 0.5s ease;\n}\n\n.gallery-item:hover .gallery-image {\n  transform: scale(1.04);\n  filter: brightness(0.92);\n}\n\n/* TABLET */\n\n@media (max-width: 900px) {\n  .salon-page {\n    background-attachment: scroll;\n    background-position: center;\n  }\n\n  .hero {\n    min-height: 850px;\n  }\n\n  .hero-overlay {\n    background: rgba(253, 248, 242, 0.82);\n  }\n\n  .hero-content {\n    padding: 100px 30px;\n  }\n\n  .hero h1 {\n    font-size: 4.5rem;\n  }\n\n  .services-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .team-card {\n    width: 270px;\n    flex-basis: 270px;\n  }\n\n  .team-photo {\n    height: 380px;\n  }\n\n  .gallery-grid {\n    grid-template-columns: repeat(2, 1fr);\n    grid-auto-rows: 280px;\n  }\n}\n\n/* MOBILE */\n\n@media (max-width: 600px) {\n  .hero h1 {\n    font-size: 3.8rem;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .services-section,\n  .booking-section,\n  .gallery-section,\n  .about-section {\n    padding: 90px 25px;\n  }\n\n  .team-section {\n    padding: 90px 0;\n  }\n\n  .team-section .section-header {\n    margin-left: 25px;\n    margin-right: 25px;\n  }\n\n  .team-card {\n    width: 240px;\n    flex-basis: 240px;\n  }\n\n  .team-photo {\n    height: 340px;\n  }\n\n  .team-track {\n    gap: 18px;\n    animation-duration: 25s;\n  }\n\n  .gallery-grid {\n    grid-template-columns: 1fr;\n    grid-auto-rows: 350px;\n  }\n\n  .gallery-item:nth-child(1),\n  .gallery-item:nth-child(4) {\n    grid-row: span 1;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
